import { FC, PropsWithChildren, ReactNode } from 'react';

interface ConditionalProps extends PropsWithChildren {
  condition: boolean;
  trueRender?: ReactNode;
  falseRender?: ReactNode;
}

export const Conditional: FC<ConditionalProps> = ({ condition, trueRender, falseRender, children }) => {
  if (condition) {
    return trueRender ?? children;
  } else {
    return falseRender ?? <></>;
  }
};
